import { css } from '@/styled-system/css';

export const chatBubbleStyles = css.raw({
  borderRadius: '500',
  whiteSpace: 'pre-wrap',
  width: 'fit-content',
  maxWidth: '396px',
  padding: 'default',
  marginBottom: 'tighter',
});

export const autoResponseChatBubbleStyles = css.raw({
  borderBottomLeftRadius: '100',
  backgroundColor: 'bg.neutral',
  border: '1px solid',
  borderColor: 'border.muted',
});

export const messageOwnerChatBubbleStyles = css.raw({
  borderBottomRightRadius: '100',
  backgroundColor: 'bg.accent.blue.soft',
  float: 'right',
});

export const defaultChatBubbleStyles = css.raw({
  backgroundColor: 'bg.softest',
  borderBottomLeftRadius: '100',
});
